const CircleRightTickIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.5911 154.589C24.4637 129.526 20.3515 84.716 45.414 54.5886C70.4766 24.4612 115.287 20.3489 145.414 45.4115C175.541 70.474 179.654 115.284 154.591 145.411C129.529 175.539 84.7186 179.651 54.5911 154.589Z"
        stroke="#007A3F"
        strokeWidth="3.95061"
      />
      <path
        d="M72.6719 110.712C77.9576 115.844 88.1414 125.734 88.1414 125.734L139.448 74.3599C139.448 74.3599 139.755 74.0919 140.242 73.5754"
        stroke="#007A3F"
        strokeWidth="4.09876"
      />
    </svg>
  );
};
export default CircleRightTickIcon;
